<template>
  <v-container class="py-10">
    <v-row justify="center">
      <v-col cols="12" sm="8" md="6">
        <v-card class="pa-8 text-center" elevation="1">
          <v-icon icon="mdi-login" size="48" color="primary" class="mb-4" />
          <h1 class="text-h5 mb-2">Sign in</h1>
          <p class="text-body-2 text-medium-emphasis mb-6">You will be redirected to Auth0 to authenticate.</p>
          <v-btn color="primary" size="large" :to="{ name: 'Login' }">Continue with Auth0</v-btn>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script lang="ts">
  import { defineComponent } from 'vue';

  export default defineComponent({
    name: 'Login',
  });
</script>
